import { createCrewLookupSelect } from './createCrewLookupSelect';

export const VesselTypeSelect = createCrewLookupSelect('VesselTypeSelect', 'vesselTypes');
export default VesselTypeSelect;
